import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {UserProfile} from "../payload-types/user-profile";

/**
 * #19351: GET {@link RevaApi.PATH_USER_PROFILE} — full name, e-mail, language and whether account
 * management is currently reachable/permitted (`editable`) for the logged-in user. Any failure (network,
 * 503, forbidden) is treated the same by callers as `editable: false` — see `fetchUserProfileThunk`.
 */
export class UserProfileApiInterface extends SimpleApiInterface<UserProfile> {
    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_USER_PROFILE]);
    }

    protected executeInternal(executor: ApiExecutor, url: string, credentials: ApiCredentials): Promise<UserProfile> {
        return executor.fetchGET(url, credentials);
    }
}
